import { render, staticRenderFns } from "./EpisodesListItem.vue?vue&type=template&id=45babcd6&"
import script from "./EpisodesListItem.vue?vue&type=script&lang=js&"
export * from "./EpisodesListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports